export default __webpack_public_path__ + "static/media/news (4).8a88e1da.webp";